import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, model, signal, ViewChild } from '@angular/core';
import { TitleComponent } from '../../../shared/components/title-component/title-component';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe } from '@angular/common';
import { Site } from '../../../shared/model';
import { Router } from '@angular/router';
import { CollaborateurService } from '../../../collaborateur/service/collaborateur-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { SiteService } from '../../service/site-service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GroupeService } from '../../../Groupe/service/groupe-service';
import { Groupe } from '../../../Groupe/model/groupe';
import { MatSelectModule } from '@angular/material/select';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Site
}

@Component({
  selector: 'app-site-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    UpperCasePipe,
    MatSpinner
  ],
  templateUrl: './site-component.html',
  styleUrl: './site-component.css',
})
export class SiteComponent {
  displayedColumns: string[] = ["id", /*"collaborateur_name",*/ "name", "groupe", "owner", "adresse", "status", "actions"];
  dataSource: MatTableDataSource<Site> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = false
  searchValue = signal<string>('')
  readonly dialog = inject(MatDialog);

  currentSite = signal<Site>(new Site())

  constructor(
    private toastr : ToastrService,
    private sweetAlert : SweetAlertService,
    private siteService : SiteService,
    private router : Router,
  ){}

  ngOnInit(): void {
    this.loading = true
    this.siteService.getAll().subscribe({
      next : (res) =>{
        this.dataSource.data = res
        this.loading = false
      },
      error : (err) =>{
        this.loading = false
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openAddSiteModal(){
    const data : ModalDataI = {
      title : 'Ajouter un Bureau',
      data : new Site()
    }

    const dialogRef = this.dialog.open(SiteComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Site) => {

      if (result?.id != undefined) {
        const data : Site[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("Le bureau "+ result.name + " à été ajouté")
      }
    });
  }

  openUpdateSite(site : Site){
    this.currentSite.set(site)

    const data : ModalDataI = {
      title : 'Modifier le bureau ' + site.name,
      update : true,
      data : this.currentSite()
    }

    const dialogRef = this.dialog.open(SiteComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : Site) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("Le bureau "+ result.name + " à été modifie")
      }
    });
  }


  confirmDeleteSite(coutier : Site){
    this.sweetAlert
    .confirm('Etez-vous sur de vouloir supprimer le bureau '+ coutier.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.siteService.delete(coutier.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != coutier.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChangeSiteState(site : Site){
    const title = site.disable?'Activation':'Desactivation'
    const action = site.disable?'activer':'desactiver'
    this.sweetAlert.confirm('Etez-vous sur de vouloir '+ action +' le bureau ' + site.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.siteService.changeStatus(site.id).subscribe({
          next : (result) =>{
            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data
            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }

  goToSiteDetails(site : Site){
    //console.log('hello');
    this.router.navigateByUrl('/bureaux/'+site.id)
  }
}

@Component({
  selector: 'app-site-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatIcon
  ],
  templateUrl: '../modal/modal-site.html',
  styleUrl: '../modal/modal-site.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteComponentModal {
  readonly dialogRef = inject(MatDialogRef<SiteComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly site = model(this.inputData.data!);

  siteForm : FormGroup = new FormGroup({})

  readonly dialog = inject(MatDialog);

  groupes : Groupe[] = []

  constructor(
    private fb : FormBuilder,
    private siteService : SiteService,
    private groupeService : GroupeService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    this.siteForm = this.fb.group({
      name : ['', [Validators.required]],
      groupe_name : [''],
      groupe_id : ['', [Validators.required]],
      owner : ['', [Validators.required]],
      adresse : ['', [Validators.required]],
    })

    this.groupeService.getAll().subscribe({
      next : (res) => {
        this.groupes = res
      }
    })
  }

  ngAfterViewInit(): void {
    this.siteForm.patchValue(this.inputData?.data!)
  }

  resetForm(){
    this.siteForm.patchValue({
      name : '',
      groupe_name : '',
      groupe_id : '',
      owner : '',
      adresse : '',
      collaborateur_id : '',
      collaborateur_name : ''
    })
  }


  onAdd(){
    const data = this.siteForm.value

    this.siteService.create(data).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    const data = this.siteForm.value;

    this.siteService.update(data, this.inputData.data?.id??'').subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

}
